module.exports = __webpack_public_path__ + "static/photo-6646d1af72cf5c93d00eff7dd71d3887.jpg";